export interface TourCategory {
  id: string;
  label: string;
}
